module.exports = __webpack_public_path__ + "img/BidAgent.a8f9d9c9.png";